import { generateUrlWithQueryParams } from "../utils/url";

export const sendMessageToChat = async (
  question,
  historyMessages,
  filters,
  exchangeName,
) => {
  const chatsApiUrl =
    process.env.REACT_APP_CHATS_API_URL ||
    "https://chat-dev.aiiro.ai/api/v2/aiirox";

  if (!chatsApiUrl) throw new Error("Not defined env file."); // should not be invoked

  const body = JSON.stringify({
    user_query: question,
    history:
      !!historyMessages && historyMessages.length > 0 ? historyMessages : [],
    company_names: filters?.companyNames,
    countries: filters?.companyCountries,
    sectors: filters?.sectors,
    exchangeName: exchangeName,
  });

  // const jwtToken = await JWTToken();

  const response = await fetch(
    generateUrlWithQueryParams(`${chatsApiUrl}/chat-stream`),
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        // Authorization: `Bearer ${jwtToken}`
      },
      body,
    }
  );

  if (!response.body) throw new Error("Response body is missing");

  const reader = response.body.getReader();
  const decoder = new TextDecoder();

  let isFirstChunk = true;
  let skipToEnd = false; // once true, stop local chunking + delays
  let carry = ""; // small look-behind to detect patterns across boundaries
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  return new ReadableStream({
    start(controller) {
      const processText = async (result) => {
        const { done, value } = result;

        if (done) {
          controller.close();
          return;
        }

        const decodedText = decoder.decode(value, { stream: true });

        // If not already detected, check if this or the carry indicates an image markdown starting
        if (!skipToEnd) {
          const look = (carry + decodedText);
          // Simple, robust trigger: start of markdown image `![` (avoid heavy regex across streams)
          if (look.includes("![") || look.includes("[[1")) {
            skipToEnd = true;
          }
        }

        if (!skipToEnd) {
          // Normal mode: split into tiny chunks with short delays for smoother typewriter effect
          const chunkSize = 12;
          let position = 0;

          if (isFirstChunk) {
            await delay(50);
            isFirstChunk = false;
          }

          while (position < decodedText.length) {
            const chunk = decodedText.slice(position, position + chunkSize);
            controller.enqueue(chunk);
            position += chunkSize;
            await delay(35);
          }
        } else {
          // Image detected: stop local chunking and enqueue full decodedText immediately (no delays)
          controller.enqueue(decodedText);
        }

        // Maintain a short carry from the tail for cross-chunk detection
        carry = (carry + decodedText).slice(-10);

        if (!response.ok) {
          throw new Error();
        }

        return reader.read().then(processText);
      };

      reader
        .read()
        .then(processText)
        .catch((err) => controller.error(err));
    },
  });
};
